const getWorker = (): SharedWorker => {
  return new SharedWorker(new URL("./worker", import.meta.url), {
    type: "module",
  });
};

export default getWorker;
